import React from "react";
import { isMobile } from "react-device-detect";

import { Box } from "@mui/material";

// Render a single tooth square.
// Memoized: the chart pages render 32-52 of these and a tap only changes one.
function Tooth(options = {}) {
    const decideBorderColor = () => {
        if (missing) return "grey.700";
        if (implant) return "#1976d2";

        return "grey.400";
    };

    const decideBackgroundColor = () => {
        if (missing) return "grey.900";
        if (implant) return "#e3f2fd";
        if (alternatingColors) {
            if (num % 2 !== 0) {
                return "background.secondary";
            } else {
                return "background.primary";
            }
        }

        return "background.primary";
    };

    const decideTextColor = () => {
        if (missing) return "grey.500";
        if (implant) return "#1976d2";

        return "text.primary";
    };

    const {
        num,
        missing,
        implant,
        handleToggle,
        alternatingColors = false,
        fontSize = isMobile ? 16 : 18,
        squareSize = isMobile ? 38 : 50,
        borderColor = decideBorderColor(),
        backgroundColor = decideBackgroundColor(),
        textColor = decideTextColor()
    } = options;

    const isDecidious = num > 50;
    const crossLength = squareSize - 16;
    const screwLength = squareSize;

    return (
        <Box
            sx={{
                width: squareSize,
                height: squareSize,
                border: isDecidious ? "2px dotted" : "2px solid",
                borderColor: borderColor,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: backgroundColor,
                position: "relative",
                cursor: handleToggle ? "pointer" : "default",
                opacity: missing ? 0.5 : 1,
                userSelect: "none",
                transition: "background 0.2s",
                fontSize: fontSize,
                fontWeight: 600,
                color: textColor
            }}
            onClick={() => (handleToggle ? handleToggle(num) : null)}>
            {num}

            {missing && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 2,
                        left: 2,
                        right: 2,
                        bottom: 2,
                        pointerEvents: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                    {/* Cross-out visual */}
                    <svg width={crossLength} height={crossLength}>
                        <line x1="0" y1="0" x2={crossLength} y2={crossLength} stroke="#fff" strokeWidth="3" />
                        <line x1={crossLength} y1="0" x2="0" y2={crossLength} stroke="#fff" strokeWidth="3" />
                    </svg>
                </Box>
            )}

            {implant && !missing && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 2,
                        right: -6,
                        pointerEvents: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                    {/* Realistic screw SVG for implant */}
                    <svg width={screwLength} height={screwLength} viewBox="0 0 38 38">
                        <g>
                            {/* Screw head */}
                            <ellipse cx="16" cy="7" rx="6" ry="3" fill="#1976d2" stroke="#115293" strokeWidth="1.5" />
                            {/* Screw shaft */}
                            <rect x="13" y="10" width="6" height="18" rx="2" fill="#1976d2" stroke="#115293" strokeWidth="1" />
                            {/* Screw thread (zigzag) */}
                            <polyline points="14,13 18,15 14,17 18,19 14,21 18,23 14,25" fill="none" stroke="#fff" strokeWidth="1.2" />
                        </g>
                    </svg>
                </Box>
            )}
        </Box>
    );
}

export default React.memo(Tooth);
